import { render, staticRenderFns } from "./Interrupts.vue?vue&type=template&id=6b90e1a0&scoped=true&"
import script from "./Interrupts.vue?vue&type=script&lang=js&"
export * from "./Interrupts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90e1a0",
  null
  
)

export default component.exports